import {CountryOf, LanguageOf, Locale} from './locale';

export function getBcp47LanguageTag<SpecificLocale extends Locale>(
  locale: SpecificLocale,
) {
  return locale.replace(
    '_',
    '-',
  ) as `${LanguageOf<SpecificLocale>}-${CountryOf<SpecificLocale>}`;
}
